import { Injectable } from "@angular/core";
import { Pays } from "../models";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable()
export class PaysService {
  private url = `/api/pays`;
  constructor(private http: HttpClient) {}
  public getAll(): Observable<[Pays]> {
    const params = new HttpParams();
    return this.http.get<[Pays]>(this.url, { params: params });
  }
  /**
   * create a  new voie dabord catheter
   * @param type voiedabord
   */
  create(pays: Pays) {
    pays.code = pays.code.toLocaleUpperCase();
    return this.http.post(this.url, pays).map(data => {
      console.log(data);
    });
  }
  /**
   * supprimer voie dabord catheter
   * @param type voiedabord
   */
  delete(pays: Pays) {
    return this.http.delete(`${this.url}/${pays.id}`).map(data => {
      console.log(data);
    });
  }
  /**
   *modifier voir dabord catheter
   * @param type voiedabord
   */
  update(pays: Pays) {
    return this.http.put(`${this.url}/${pays.id}`, pays).map(data => {
      console.log(data);
    });
  }
  get(id: Number): Observable<Pays> {
    return this.http.get<Pays>(`${this.url}/${id}`);
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/pays.service.ts